import { useState, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "../components/ui/sidebar";
import Footer from "../components/ui/footer";
import { HiBars3 } from "react-icons/hi2";
import useLipaBidhaaStore from "../stores/lipaBidhaaStore";
import useFundsTransferStore from "../stores/fundsTransferStore";
import useBulkUploadsStore from "../stores/bulkUploadsStore";
import useManualEntryStore from "../stores/manualEntryStore";
import useFileUploadStore from "../stores/fileUploadStore";

export function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const isDocsRoute = location.pathname.startsWith("/developer-apis/docs");

  const prevPathnameRef = useRef(location.pathname);
  const mainRef = useRef(null);
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  useEffect(() => {
    setIsSidebarOpen(false);
    const prev = prevPathnameRef.current;
    const curr = location.pathname;

    if (prev === curr) {
      // Initial mount after a full page reload — clear stale manual-entry data
      // if the app started outside the manual-entry route.
      if (!curr.startsWith("/bulkpayments/manual-entry")) {
        useManualEntryStore.getState().reset();
      }
      if (!curr.startsWith("/bulkpayments/file-upload")) {
        useFileUploadStore.getState().reset();
      }
    } else {
      mainRef.current?.scrollTo({ top: 0, behavior: "instant" });
      if (prev.startsWith("/lipa-bidhaa") && !curr.startsWith("/lipa-bidhaa")) {
        useLipaBidhaaStore.getState().reset();
      }
      if (prev.startsWith("/funds-transfer") && !curr.startsWith("/funds-transfer")) {
        useFundsTransferStore.getState().reset();
      }
      if (prev.startsWith("/bulkpayments") && !curr.startsWith("/bulkpayments")) {
        useBulkUploadsStore.getState().reset();
      }
      if (prev.startsWith("/bulkpayments/manual-entry") && !curr.startsWith("/bulkpayments/manual-entry")) {
        useManualEntryStore.getState().reset();
      }
      if (prev.startsWith("/bulkpayments/file-upload") && !curr.startsWith("/bulkpayments/file-upload")) {
        useFileUploadStore.getState().reset();
      }
    }

    prevPathnameRef.current = curr;
  }, [location.pathname]);

  return (
    <div className="flex w-full h-screen bg-gray-50 font-montserrat">
      {/* Sidebar */}
      {!isDocsRoute && (
        <div className="">
          <Sidebar
            className="h-screen sticky top-0"
            isOpen={isSidebarOpen}
            onClose={toggleSidebar}
          />
        </div>
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Hamburger menu (mobile only) */}
        {!isDocsRoute && (
          <div className="sticky top-0 z-10 bg-gray-50/80 backdrop-blur-md md:hidden flex items-center p-2">
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-md bg-white shadow text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <HiBars3 className="h-6 w-6" />
            </button>
          </div>
        )}

        {/* Main scrollable content */}
        <main ref={mainRef} className={`flex-1 overflow-y-auto overflow-x-hidden min-w-0 ${isDocsRoute ? "" : "p-4 pb-24"}`}>
          <Outlet />
        </main>

        {!isDocsRoute && <Footer />}
      </div>

      {/* Overlay (mobile only) */}
      {!isDocsRoute && isSidebarOpen && (
        <div
          className="fixed inset-0 bg-[#28282880] z-[430] lg:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
}
